import ApeironComponent from '@/components/commons/apeiron-component.model';
import { ActividadRetribucion, MenuGenerico, VinculacionRetribucion } from '@/shared/model/ars/ars.model';
import CatalogosArs from '@/shared/model/ars/catalogos-ars.factory';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';

const validations = function () {
  return {
    vinculacionForm: {
      areaConocimiento: { required },
      temasPrioritarios: { required },
    },
  };
};

@Component({
  validations,
})
export default class ActividadVinculacionArsComponent extends ApeironComponent {
  @Prop({ required: true })
  public readonly solucion!: Solucion;

  @Prop({ required: true })
  public readonly solicitud!: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  public vinculacionForm: VinculacionRetribucion = new VinculacionRetribucion(); // se pobla con los datos del property

  public opcionesAreasConocimiento: Array<MenuGenerico> = [];
  public opcionesPrioridades: Array<MenuGenerico> = [];

  public mounted(): void {
    this.opcionesAreasConocimiento = CatalogosArs.obtenerAreasConocimiento().map(area => new MenuGenerico(area.descripcion, area)) ?? [];
    this.opcionesPrioridades =
      CatalogosArs.obtenerTemasPrioritarios().map(prioridades => new MenuGenerico(prioridades.descripcion, prioridades)) ?? [];

    if (this.solicitud.vinculacionRetribucion) {
      this.vinculacionForm = VinculacionRetribucion.fromObject(this.solicitud.vinculacionRetribucion);
    }
  }

  public guardarVinculacion(): void {
    this.$emit('submit', { vinculacionRetribucion: this.vinculacionForm });
  }

  get esReadOnly(): boolean {
    return this.readOnly;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }

  get desactivarBoton(): boolean {
    return this.$v.$invalid;
  }
}
